import partnerClient from "../partnerClient";

export const fetchPartnerMessages = async (params) => {
  const { data } = await partnerClient.get("/messages", { params });
  return data?.data ?? data;
};

export const sendPartnerMessage = async (body) => {
  const { data } = await partnerClient.post("/messages", body);
  return data?.data ?? data;
};

export const markPartnerMessagesRead = async (messageIds) => {
  const { data } = await partnerClient.post("/messages/mark-read", { messageIds });
  return data?.data ?? data;
};

export const fetchPartnerUnreadMessageCount = async () => {
  const { data } = await partnerClient.get("/messages/unread-count");
  return data?.data ?? data;
};
